import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type LoginIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const LoginIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: LoginIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  // Decorative: unlike most icons here (aria-label + role='img'), this one
  // is aria-hidden. It always sits beside text that carries the meaning (a
  // StatTile label, a feed row title), so a label would only repeat or
  // contradict it, and a hardcoded English one wouldn't be translated.
  return (
    <svg
      aria-hidden='true'
      className={className}
      fill='none'
      height={size}
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='m10 17 5-5-5-5'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M15 12H3'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
